export function getdata() {
	let obj = {
		formdatajbxx: {
			cains: "",
			qij: "",
			mingxlx: "-1",
			currency: "",
			sfjdsc: "0",
			cwjd: ""
		},
		formlistjbxx: [{
				prop: "cains",
				label: "财务年度	",
				type: "select",
				selectval: [],
				isnotnull: true,
			},
			{
				prop: "qij",
				label: "财务期间	",
				type: "select",
				selectval: [],
				isnotnull: true,

			},
			{
				prop: "sfjdsc",
				label: "是否季度生成	",
				type: "select",
				isnotnull: true,
				selectval: [{label:"是",value:"1"},{label:"否",value:"0"}],
			},
			{
				prop: "mingxlx",
				label: "明细类型	",
				type: "select",
				isnotnull: true,
				selectval: [],

			},
			{
				prop: "currency",
				label: "币种	",
				type: "select",
				selectval: [],
				isnotnull: true,
				slot: true,
			},
			{
				prop: "cwjd",
				label: "财务季度	",
				type: "select",
				selectval: [{label:"Q1",value:"1"},{label:"Q2",value:"2"},{label:"Q3",value:"3"},{label:"Q4",value:"4"}],
				disabled: true
			}
		],
	}
	return obj
}
